import { createIcon } from '@chakra-ui/react';

export const Geography = createIcon({
  displayName: `Geography`,
  viewBox: `0 0 45.797 45.6`,
  path: (
    <g transform="translate(-909.762 315.676)">
      <circle
        cx="21.5"
        cy="21.5"
        r="21.5"
        transform="translate(911.31 -314.326)"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2.5"
      />
      <path
        d="M939.1-313.847s-1.523,2.835-2.469,3.173-5.064,1.147-5.4,1.823-2.768,2.688-1.08,5.024,1.62,2.47,2.633.884a2.352,2.352,0,0,1,2.638-1.071"
        transform="translate(-5.18 -0.136)"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2.5"
      />
      <path
        d="M947.676-298.063s2.941.719,3.144,2.742,1.874,4.386,2.354,4.25,3.789-1.553,3.924-2.228,1.081-2.5,2.633-.54,1.418,3.308,1.958,3.713,1.08-2.565,2.025-2.161"
        transform="translate(-10.324 -4.617)"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2.5"
      />
      <path
        d="M935.376-295.2c-2.97-.067-4.321-.305-5.671,1.7s-1.553,2.544-1.688,3.83.27,4.516,3.679,4.622,3.544.106,3.949,1.861,1.418,1.891,1.147,2.97-.652,3.106.045,4.523,1.23,3.714,2.72,3.308,2.3-2.363,3.177-3.848,2.025-1.755,2.025-3.375-.072-3.646,1.213-4.591,1.745-2.093.6-2.5-2.964-4.118-4.652-6.279-3.428.675-4.313.067A15.311,15.311,0,0,1,935.376-295.2Z"
        transform="translate(-4.737 -5.417)"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2.5"
      />
      <path
        d="M957.509-275.006s.675.877,0,3.038-2.559,5.468-2.664,2.768.368-3.071.841-3.629S957.509-275.006,957.509-275.006Z"
        transform="translate(-12.355 -11.162)"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2.5"
      />
      <path
        d="M911.491-281.387a10.357,10.357,0,0,1,3.267-.975c1.534-.107,1.958,1.623,3.443,2.229s3.588.67,3.82,1.888.028,2.7.433,3.444a2.126,2.126,0,0,1-1.35,2.7c-1.293.432-1.351,4.658-1.351,4.658"
        transform="translate(-0.052 -9.073)"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2.5"
      />
      <path
        d="M918.77-306.93s2.037.645,2.239,2.065a4.8,4.8,0,0,1-1.12,4.323c-1.243,1.147-1.394,3.51-2.5,4.186s-2.861,1.013-2.254,1.891,1.418,2.16.2,2.16-2.978.384-3.7-.586"
        transform="translate(-0.092 -2.1)"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2.5"
      />
      <path
        d="M941.726-299.735c.284.06,1.389.3,1.389.3"
        transform="translate(-8.635 -4.142)"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2.5"
      />
    </g>
  ),
});
